import { set } from 'lodash';

export default function createInitialValues(fields) {
  const values = {};

  Object.keys(fields).forEach((key) => {
    const fieldsSection = fields[key].fields;

    const isArray = fields[key].type === 'array';
    const arrayFieldName = fields[key].name;

    if (isArray) {
      const arrayFieldInitialValues = createInitialValues([
        {
          title: fields[key].title,
          fields: fields[key].fields,
        },
      ]);

      set(values, arrayFieldName, [
        { ...(arrayFieldInitialValues ?? {}), id: Math.random().toString() },
      ]);
      return;
    }

    fieldsSection.forEach((field) => {
      if (field.innerFields && !field?.noInitialValue) {
        const innerValues = field.innerFields.reduce((acc, innerField) => {
          if (innerField.type !== 'component') {
            acc[innerField.name] = innerField.defaultValue || '';
          }
          return acc;
        }, {});

        set(values, field.name, [innerValues]);
        return;
      }

      set(values, field.name, field.defaultValue || '');
    });
  });

  return values;
}
